import { Component, OnInit } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataStorageService } from '../../shared/data-storage.service';
import { NGXLogger } from 'ngx-logger';

//import { BillerService } from '../../biller/Biller.service';
import { User } from '../../shared/auth/user';
import { LoginService } from '../../login.service';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private loginservice: LoginService,
    //private billerservice: BillerService,
    private dataStorageService: DataStorageService,
    private translate: TranslateService, private logger: NGXLogger, private router: Router) {

  }
  isbangla: Boolean = true;
  iseng: Boolean;
  userS: string;
  isReady: boolean;
  lang: string;
  isMyaccount: boolean = false;
  subscription: Subscription;
  user: User;
  isWallet: boolean = false;

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + data);
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      if(this.router.url=='/'){
        this.lang='en';
      }
      this.translate.use(this.lang);
    })
    this.subscription = this.dataStorageService.userData$.subscribe((data) => {
      this.user = data as User;
      sessionStorage.setItem("user", JSON.stringify(this.user));
    })
    if (sessionStorage.getItem("user") == undefined || sessionStorage.getItem("user") == 'undefined') {
      this.user = JSON.parse(localStorage.getItem("sessuser")) as User;
    } else {
      this.user = JSON.parse(sessionStorage.getItem("user")) as User;
      sessionStorage.setItem("sessuser", JSON.stringify(this.user));
    }
    this.user = JSON.parse(localStorage.getItem("sessuser")) as User;
    //this.logger.debug("user..." + JSON.stringify(this.user));

    if (this.user != null) {
      if ((this.user.roles.toString().includes("ROLE_SYNDICATE"))) {
        this.isWallet = true;
      }
    }

    //this.logger.debug('header component called..' + sessionStorage.getItem("lang"));
    if (localStorage.getItem("lang") == 'bn') {
      this.isbangla = true;
      this.iseng = false;
    } else {
      this.iseng = true;
      this.isbangla = false;
    }
    this.isReady = true;
  }

  onclick(val) {
    //this.logger.debug('language should be..' + val);
    if (val == 'bn') {
      this.isbangla = true;
      this.iseng = false;
    } else {
      this.iseng = true;
      this.isbangla = false;
    }
    this.translate.use(val);
    localStorage.setItem("lang", val);
    this.dataStorageService.setLangData(val);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts